import { useWriteContract } from "wagmi";
import {
  PRESALE_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
} from "../../../constants";
import { usdtAbi } from "../../../abis/usdtAbi";
import { handleWriteContractError } from "../../../helpers";
import { toast } from "react-toastify";

export function useApproveUSDT() {
  const { data, error, writeContractAsync, isPending, isSuccess } =
    useWriteContract();

  const approveUSDT = async (amountOfTokensToApprove: bigint) => {
    try {
      return await writeContractAsync({
        address: USDT_CONTRACT_ADDRESS,
        abi: usdtAbi,
        functionName: "approve",
        args: [PRESALE_CONTRACT_ADDRESS, amountOfTokensToApprove],
      }).then(() => toast.success("Transaction successfully submitted"));
    } catch (error) {
      return null;
    }
  };

  if (error) {
    return handleWriteContractError(error);
  }

  if (!data && !approveUSDT) return null;

  return { approveUSDTHash: data, approveUSDT, error, isPending, isSuccess };
}
